<template>
<div class="chapter">
<div class="inner_page">
<div class="copyright" id="copyrightPage">
<p class="copyrightTextS"><span class="character-style7">Published by</span></p>
<p class="copyrightText"><span class="character-style7">Grub Street<br/>4 Rainham Close<br/>London</span></p>
<p class="copyrightText"><span class="character-style7">SW11 6SS</span></p>
<p class="copyrightText1"><span class="character-style7">Copyright © Grub Street 2010</span></p>
<p class="copyrightText"><span class="character-style7">Copyright text © Dr Steve Bond 2010</span></p>
<p class="copyrightText"><span class="character-style7">Copyright foreword © Air Marshal Sir Roger Austin KCB AFC FRAeS RAF</span></p>
<p class="copyrightText3"><span class="character-style7">2010</span></p>
<p class="copyrightText1-1"><span class="character-style7">British Library Cataloguing in Publication Data</span></p>
<p class="copyrightText"><span class="character-style7">Bond, Steve.</span></p>
<p class="copyrightText"><span class="character-style7">Heroes all : airmen of different nationalities tell their stories of service in the Second World War.</span></p>
<p class="copyrightText"><span class="character-style7">1. World War, 1939-1945--Aerial operations. 2. World War,</span></p>
<p class="copyrightText"><span class="character-style7">1939-1945--Personal narratives.</span></p>
<p class="copyrightText"><span class="character-style7">I. Title<br/>940.5’44’0922-dc22</span></p>
<p class="copyrightText1"><span class="character-style7">ISBN-13: 9781906502713</span></p>
<p class="copyrightText"><span class="character-style7">eISBN: 9781908117861</span></p>
<p class="copyrightText1"><span class="character-style7">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means electronic, mechanical, photocopying, recording or otherwise, without the prior permission of the copyright owner.</span></p>
<p class="copyrightText1"><span class="character-style7">Cover design and typesetting by Sarah Driver</span></p>
<p class="copyrightText1"><span class="character-style7">Edited by Sophie Campbell</span></p>
<p class="copyrightText1"><span class="character-style7">Printed and bound by MPG Ltd, Bodmin, Cornwall</span></p>
<p class="copyrightText1"><span class="character-style7">Grub Street Publishing only uses</span></p>
<p class="copyrightText"><span class="character-style7">FSC (Forest Stewardship Council) paper for its books.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// HeroesAll_copyright.vue?7c240e58